import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { LoaderService } from "@core/components/loaders/services/loader.service";
import { selectPageLoading } from '@app/core/store';
import { logIn, logOut, logInFailed } from '@auth/store/actions/auth.actions';
import {
  State,
  errorMessageSelector,
} from '@auth/store/reducers/auth.reducers';
import { AdminAuthService } from './service/admin-auth.service';
/**
 * Login component which handles the user authentication and stores
 * the tokens in the local storage
 */
@Component({
  selector: 'app-admin-login',
  templateUrl: './admin-login.component.html'
})
export class AdminLoginComponent implements OnInit, AfterViewInit {
  form: FormGroup;
  loading$: Observable<boolean>;
  loginErrorMsg$: Observable<string>;
  resetPassword: boolean;


  /**
   * Default contructor
   * @param {object} formBuilder
   * @param {object} authenticationService
   * @param {object} loaderService
   * @param {object} router
   * @param {object} store
   */
  constructor(
    private formBuilder: FormBuilder,
    private authenticationService: AdminAuthService,
    private router: Router,
    private loaderService: LoaderService,
    private store: Store<State>
  ) { }
  /**
   * Initializer method
   */
  ngOnInit() {
    this.form = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
    if (this.authenticationService.isLogged()) {
      this.router.navigate(['/']);
    }
    this.loginErrorMsg$ = this.store.select(errorMessageSelector);
    this.loading$ = this.store.select(selectPageLoading, {
      feature: 'Auth',
    });
  }
  /***
   * Add styleName to html root element
   */
  ngAfterViewInit() {
    (document.querySelector('html') as HTMLElement).className = 'login';
  }
  /**
   *  Send the form data to remote rest service
   */
  onSubmit(): void {
    const user = {
      username: this.form.controls.username.value,
      password: this.form.controls.password.value,
    };
    this.loaderService.show();
    this.authenticationService.authenticateUser(user).subscribe(
      data => {
        if (this.authenticationService.isChangePasswordRequired()) {
          this.resetPassword = this.authenticationService.isChangePasswordRequired();
        } else {
          this.store.dispatch(logIn(user));
          this.router.navigate(["/"]);
        }
        this.loaderService.hide();
      },
      error => {
        this.loaderService.hide();
        this.store.dispatch(logInFailed(error));
      }
    );
  }
  onResetSuccess(event) {
    if (event) {
      this.resetPassword = false;
      //this.store.dispatch(logOut({}));
    }
  }
  changePassword(): void {
    this.resetPassword = true;
  }
}
